import { Link } from "react-router-dom";
import Header from "../components/Header/Header";
import PageBanner from "../components/about/PageBanner";
import Counter from "../components/Counter";
import Footer from "../components/Footer/Footer";
import { Fade } from "react-awesome-reveal";
import AboutCube from "../components/about/AboutCube";
import ImageMasonry from "../components/masonary/MasonaryAbout";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchTranslations } from "../actions/languageActions";
import NewHeader from "../components/Header/NewHeader";
import Loading from "../components/loading/Loading";
import FormModal from "../elements/FormModal";
import { Helmet } from "react-helmet-async";
// import Typewriter from "typewriter-effect";
const handleChnge = () => {
  onclick = "window.print()";
};
const DemoPage = () => {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const translations = useSelector((state) => state.language.translations[selectedLanguage]);
  
  useEffect(() => {
    dispatch(fetchTranslations(selectedLanguage));
  }, [dispatch, selectedLanguage]);
  
  if (!translations) {
    return <div>
      <Loading/>
    </div>; // Show loading state while translations are being fetched
  }
  
  const { aboutus } = translations;
  const industryList = aboutus.industry.list;
  const learnUs = aboutus.learnUs.list;
  return (
    <>
      <Helmet>
<title>Outcome-Based Assessment (OBA) - Signet Institute of Australia</title>
<meta name='description' content='Outcome Based Assessment OBA at Signet Institute of Australia with expert preparation, practical training and personalised support. Explore your pathway today.' data-rh="true" />
</Helmet>
      <NewHeader />
      {/* <PageBanner pageName={"About us"} /> */}

      {/* <Fade delay={1e3} triggerOnce cascade damping={1e-5}> */}

      {/* page banner */}

      {/* page banner */}
      {/* Page Banner End */}

      <div className="about-sec-">
        <section class="pt-150 nanhe">
        
          <div className="container">
            <div className="row">
              <div className="col-md-6 pt-60">
                <h1 className="title-banner ">
                  Outcome-Based Assessment (OBA)
                </h1>
                <a href="#popup1" className="theme-btn my-15">
                       Get Started <i className="fas fa-arrow-right" />
                </a>
                
                <a href="#enrol" className="theme-btn mx-3 my-15">
                      Enrol Now <i className="fas fa-arrow-right" />
                </a>
              </div>
              <div className="col-md-6 ">
                <div className="banner-ab-image text-center">
                  <img src="/img/policy/obaa_.jpeg"/>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="about-page-section pt-60 pb-65 rpt-90">
            <div className="container">
                <div className="row">
                   <div className="col-md-12"> 
                   <p>If you are an internationally trained nurse aiming to build your career in Australia, the Outcome Based Assessment (OBA) preparatory program offers a valuable pathway forward. This program, introduced in March 2020 has opened doors for nurses and midwives around the world, helping them take meaningful steps toward Australian registration and employment.</p>                       
                        <p>The OBA program supports internationally qualified professionals in meeting the standards required by the Nursing and Midwifery Board of Australia (NMBA). Gaining NMBA registration is a mandatory step before you can begin working as a nurse or midwife in Australia. This process also creates the opportunities to pursue permanent residency and it establishes a long-term future in the healthcare system of Australia.</p>
                    </div>
                    <div className="col-md-12 pt-20">
                    <div class="whitebg">
                          <h4>About the course</h4>
                            <p>This specialised program, mandated by the Nursing and Midwifery Board of Australia (NMBA) under the Australian Health Practitioners Regulation Authority (AHPRA), is designed to prepare internationally qualified nurses for the Outcome Based Assessment (OBA). The OBA is a standardised evaluation introduced by AHPRA to determine whether candidates are ready for licensure as entry-level nurses in Australia.</p>
                            <p>Students will receive training to prepare for two key components of the OBA. First one is the Objective Structured Clinical Examination (OSCE) and the second one is the National Council Licensure Examination for Registered Nurses (NCLEX-RN). The NCLEX-RN, administered by AHPRA, is a comprehensive test that assesses a candidate’s ability to safely and effectively practice as an entry-level nurse in Australia. Those who have completed a nursing program and wish to work as registered nurses in Australia, it is compulsory for them to pass this exam.</p>
                            <p>The OSCE evaluates clinical skills and critical thinking through practical scenarios, while our course at Signet Institute of Australia is tailored to equip nurses with the knowledge, skills, and confidence to succeed in both assessments.</p>
                            <p><strong>Course Objectives:</strong></p>
                            <p><ul><li>Equip participants to successfully complete the Outcome Based Assessment required for registration as an Australian nurse.</li><li>Provide overseas qualified nurses with supervised, supported training in an Australian healthcare simulation environment, preparing them for the OSCE and/or assisting with focused NCLEX preparation.</li></ul></p>
                        
                        </div>
                        <div class="whitebg">
                          <h4>Program Options </h4>
                          <img src="/img/policy/oba-course.png"/>
                              <p><strong>OPTION A - Recommended for IQNMs</strong></p>
                              <p>RN-OFFSHORE- Self-Paced Learning (Online-Up to 40 hours) + (10 sessions- Face to face- Lab tutorial & practice + 1 Mock OSCE -2 weeks) – prior scheduled OSCE by AHPRA</p>
                              <p><ul><li><strong>SELF-PACED ONLINE</strong> </li>
                              <ol>1.	Online discussion on NCLEX-RN MCQs </ol>
                              <ol>2.	Trainer provides continuous support and guidance to candidates via teams or emails- providing feedback</ol>
                              <ol>3.	Pre-recorded tutorial on practical skills will be provided to off-shore candidates</ol>
                              </ul></p>
                              <p><ul><li><strong>10 SESSIONS OF FACE TO FACE ON CAMPUS</strong> </li>
                              <ol>1.	Pre- briefing- on rules, regulation, nursing standards and case scenarios </ol>
                              <ol>2.	Introduction to various types of documentation</ol>
                              <ol>3.	Trainer demonstrates the clinical skills </ol>
                              <ol>4.	Candidate practice skills- using step- by-step checklist </ol>
                              <ol>5.	Debriefing and feedback session with trainer </ol>
                              <ol>6.	MOCK OSCE x 1 per candidate </ol>
                              </ul></p> 

                              <p><strong>OPTION B</strong></p>
                              <p>RN ONSHORE-(Online NCLEX-RN review- 2 weeks) + (Face to face training + tutorial + 1 Mock OSCE- 10 session- 2 weeks)</p>
                              <p><ul><li><strong>SELF-PACED ONLINE </strong> </li>
                              <ol>1.	Online discussion on NCLEX-RN MCQs  </ol>
                              <ol>2.	Trainer provides continuous support and guidance to candidates via teams or emails- providing feedback</ol>
                              </ul></p>
                              <p><ul><li><strong>10 SESSIONS OF FACE TO FACE ON CAMPUS</strong> </li>
                              <ol>1.	Pre- briefing- on rules, regulation, nursing standards and case scenarios </ol>
                              <ol>2.	Introduction to various types of documentation</ol>
                              <ol>3.	Trainer demonstrates the clinical skills </ol>
                              <ol>4.	Candidate practice skills- using step- by-step checklist </ol>
                              <ol>5.	Debriefing and feedback session with trainer </ol>
                              <ol>6.	MOCK OSCE x 1 per candidate </ol>
                              </ul></p> 

                              <p><strong>OPTION C</strong></p>
                              <p><strong>RN ONSHORE (CRUSH COURSE) (5 SESSIONS) For advance candidates with >5 years’ experience</strong></p>
                              <p><ul>
                              <ol>1.	Trainer provides pre-briefing on Australian Nursing standards, review case scenarios</ol>
                              <ol>2.	Candidate practice skills- using step- by-step checklist</ol>
                              <ol>3.	Trainer – debrief and provide feedback</ol>
                              <ol>4.	Additional cost for mock OSCE </ol>
                              </ul></p> 
                          </div>
                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-2" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-2"><h4>Delivery </h4></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>The Blended Learning program offers a combination of lab demonstration and practice sessions along with e-learning delivery. Lab
sessions are conducted in a well-equipped nursing lab with mannequins and necessary devices. E-learning is facilitated through the
Canvas Learning management system, providing resources for NCLEX and OSCE preparation, medication calculation, and nursing
practices regulation in Australia.</p>
                            </div>
                          </div>
                        </div>
                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-3" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-3"><h4>Location </h4></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>Melbourne, 341 Queen St, Level 5, 9, Melbourne, Victoria 3000.  </p>
                            </div>
                          </div>
                        </div>
                        
                        
                        <div class="faq-drawer">
                          <input class="faq-drawer__trigger" id="faq-drawer-4" type="checkbox" /><label class="faq-drawer__title" for="faq-drawer-4"><h4>Requirements</h4></label>
                          <div class="faq-drawer__content-wrapper">
                            <div class="faq-drawer__content">
                            <p>
                            <ul><li>Must be a qualified Registered Nurse from their respective countries and completed self- check assessment with AHPRA. <a class="gunu" href="https://www.nursingmidwiferyboard.gov.au/Accreditation/IQNM/Self-check-and-Portfolio/Completing-the-Self-check.aspx">https://www.nursingmidwiferyboard.gov.au/Accreditation/IQNM/Self-check-and-Portfolio/Completing-the-Self-check.aspx</a></li>
                            <li>Must be in Stream B* </li>
                            </ul></p>
                            </div>
                          </div>
                        </div>
                        
                        
                    </div>
                    <div id="enrol" class="col-md-12 pt-40 text-center">
                        <h4>Join us at Signet Institute and unlock your potential as a nurse in Australia. With our OBA program, you'll receive the guidance and support
you need to thrive in your nursing career</h4>
                        <p class="text-center mb-30">Your journey to success starts here.</p>
                    </div>
                    <iframe src="https://signetinstituteofaustralia.getomnify.com/widgets/COXK3V4CCKW7YS12SS3F8D" frameborder="0" scrolling="yes" seamless="seamless"></iframe>
                  <div id="popup1" class="overlay">
                        <div class="popup">
                          <a class="close" href="#">&times;</a>
                          <div class="content">
                          <p><iframe src="https://forms.zohopublic.com.au/signetinstituteofaustralia/form/OBAResgistrationForm/formperma/Mpy7lxB9_j83A5CH-eYoehUKa-BlS_3QRtXZX6tDbYc" frameborder="0" scrolling="yes" seamless="seamless"></iframe></p>
                          </div>
                        </div>
                      </div>
                </div>
            </div>
        </section>
      </div>
      {/* </Fade> */}
      <Footer />
    </>
  );
};
export default DemoPage;
